import React from 'react';
import UserBetRecordModal from './UserBetRecord/UserBetRecordModal';
import AgentDetailPayModal from '@ViewsDashboard/Agent/AgentList/AgentDetail/AgentDetailPayModal';
import UpdateAgentModal from './UpdateAgent/UpdateAgentModal';
import ChangeUserModal from './ChangeUser/ChangeUserModal';

class UserModal extends React.Component {
  render() {
    return (
      <div>
        <UserBetRecordModal />
        <AgentDetailPayModal />
        <UpdateAgentModal />
        <ChangeUserModal />
      </div>
    )
  }
}

export default UserModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserModal.jsx